import type { Channel } from '@novachat/shared';
import { Hash, Lock } from 'lucide-react';
import { fileUrl } from '../lib/upload';

/** The channel's logo when it has one, otherwise # (or a lock for private channels). */
export function ChannelIcon({ channel, size, className = '' }: { channel: Channel; size: number; className?: string }) {
  if (channel.logoUrl) {
    return <img src={fileUrl(channel.logoUrl)} alt="" className={`flex-none object-cover ${className}`} style={{ width: size, height: size, borderRadius: size * 0.28 }} />;
  }
  const Icon = channel.visibility === 'private' ? Lock : Hash;
  return <Icon size={size} className={`flex-none ${className}`} aria-hidden="true" />;
}
